import {inject, injectable} from 'inversify';
import {FirebaseService} from './firebase.service';
import {UnverifiedEmailException} from "../exceptions/unverified-email.exception";
import {UnverifiedPhoneNumberException} from "../exceptions";
import {User} from "firebase/auth";

@injectable()
export class AuthService {
    @inject(FirebaseService)
    private firebaseService: FirebaseService;
    private authenticated = null;

    public signIn(email: string, password: string, keepLoggedIn: boolean = false): Promise<string> {
        return this.firebaseService.signInWithEmailAndPassword(email, password, keepLoggedIn).then((userCredential) => {
            // phone number check must be done first.
            if (!userCredential.user.phoneNumber) {
                throw new UnverifiedPhoneNumberException();
            } else if (!userCredential.user.emailVerified) {
                throw new UnverifiedEmailException();
            }

            this.authenticated = true;
            return this.firebaseService.getUserIdToken();
        });
    }

    public signInWithEmailLink(email: string): Promise<string> {
        return this.firebaseService.signInWithEmailLink(email).then(() => {
            this.authenticated = true;
            return this.firebaseService.getUserIdToken();
        })
    }

    public getCurrentUser(): User {
        return this.firebaseService.getCurrentUser();
    }

    public isAuthenticated(): Promise<boolean> {
        return new Promise((resolve) => {
            if (this.authenticated !== null) {
                resolve(this.authenticated);
            } else {
                this.firebaseService.onAuthStateChanged((user) => {
                    this.authenticated = !!(user && user.emailVerified);
                    resolve(this.authenticated);
                });
            }
        });
    }

    public logout(): Promise<void> {
        this.authenticated = false;
        return this.firebaseService.signOut();
    }

    public getUserIdToken(): Promise<string> {
        return this.firebaseService.getUserIdToken();
    }
}
